import React from "react";
import "./logo-style.css";

const AngularLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="31.5"
      height="36"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 448 512"
      className="angular-logo"
    >
      <path
        fill="currentColor"
        d="M185.7 268.1h76.2l-38.1-91.6l-38.1 91.6zM223.8 32L16 106.4l31.8 275.7l176 97.9l176-97.9l31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
      />
    </svg>
  );
};

export default AngularLogo;
